/* eslint-disable react/jsx-pascal-case */
import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
  CmpTextFieldEnter,
  CmpStatusIcon,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import { Summary_Grid_Columns, statusData } from "./PutAwayAction";
import moment from "moment";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import PutAway_BreadCrumbs from "./PutAway_BreadCrumbs";
import useMediaQuery from "@mui/material/useMediaQuery";
import GCSummaryModal from "../../Component/Common/ReuseableComponent/GCSummaryModal";
import InputDisplay from "./processComponent/InputDisplay";
import { Stack } from "@mui/material";
import CardComp from "../../Component/Common/ReuseableComponent/Card";
import dayjs from "dayjs";

export default function PutAway() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const LocationFocusOnLoad = useRef(null);
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const [sSummaryGridRow, setSummaryGridRow] = useState([]);
  const sEnterKeyObj = {
    key: "Enter",
  };
  const [sSummaryObj, setSummaryObj] = useState({
    loc: vRdxuserLoc[0]?.UID,
    Status: "All",
    dateTo: dayjs().toDate(),
    dateFrom: dayjs().startOf("month").toDate(),
    GrnNo: "",
  });
  const fSummary_OnChange = (e) => {
    setSummaryObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnKeyUp = async (e) => {
    if (e.key === "Enter") {
      if (sSummaryObj.GrnNo !== "") {
        Get_Load_Grid_Data();
      } else {
        fAlertToast("FAILED", "Wrong Barcode");
      }
    }
  };
  const fLoad = (e) => {
    Get_Load_Grid_Data();
  };
  
  const Get_Load_Grid_Data = useCallback(async () => {
    var vSummaryObj = {
      loc: sSummaryObj.loc === "" ? vRdxuserLoc[0]?.UID : sSummaryObj?.loc,
      postDt: dayjs(sSummaryObj?.dateTo).format("MM/DD/YYYY"),
      status: sSummaryObj?.Status,
      vocNo: sSummaryObj?.GrnNo,
      postDtFrom: dayjs(sSummaryObj?.dateFrom).format("MM/DD/YYYY"),
    };
    // var vSummaryObj = {
    //   vocNo: "",
    //   postDt: "2022-11-02",
    //   loc: "All",
    //   status: "All",
    // };

    const vItemSearch = await fExecuteAPI(
      "PUTAWAY_getPutAwaySummary_GETROW",
      vSummaryObj
    );
    if (vItemSearch?.Type?.toUpperCase() === "SUCCESS") {
      if (vItemSearch?.ResultSet?.length > 0) {
        const itemRows = vItemSearch?.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setSummaryGridRow(itemRows);
      } else {
        setSummaryGridRow([]);
      }
    } else {
      fAlertToast("FAILED", vItemSearch?.Message);
    }
    setShowModal(false);
  }, [
    sSummaryObj.loc,
    sSummaryObj.dateTo,
    sSummaryObj.dateFrom,
    vRdxuserLoc,
    sSummaryObj.Status,
    sSummaryObj.GrnNo,
  ]);

  const fRowCLick = (item) => {
    navigate("/PutAwayDetail", {
      state: {
        GRNDocTyp: item?.row?.A_VocTyp,
        GrnDocNo: item?.row?.A_VocNo,
        PUTAWAYFromNotification: "N",
      },
    });
  };

  useEffect(() => {
    Get_Load_Grid_Data();
  }, []);

  useEffect(() => {
    LocationFocusOnLoad.current?.focus();
  }, []);

  // modal start

  const [showModal, setShowModal] = useState(false);

  // modal end

  // const [sSummaryGridColumn2, setSummaryGridColumn2] = useState([]);

  // useEffect(() => {
  //   GetGitterColumns(
  //     setSummaryGridColumn2,
  //     "WMINV03BIN_SUMMARY",
  //     Summary_Grid_Columns
  //   );
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    // container-fluid
    <div className="my-3">
      <div className="Breadcrumbs d-flex justify-content-between align-items-center">
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <PutAway_BreadCrumbs />
        <CmpButton
          xbtnName="Filter"
          xOnClick={() => {
            setShowModal(true);
          }}
          xVariant="contained"
          xSize="small"
        />
      </div>
      {/* className="Instant-picking-head"  */}
      <Box
        sx={{ height: vMediaQuery ? "50vh" : "70vh", width: "100%" }}
        // className="bin-transfer-data"
      >
        {/* className="easy-putaway-container" */}
        <Grid container spacing={1}>
          {Array.isArray(sSummaryGridRow) &&
            sSummaryGridRow?.length > 0 &&
            sSummaryGridRow?.map((data, index) => (
              <Grid item xs={12} sm={6} lg={4} key={index}>
                <CardComp
                  data={data}
                  onClick={(item) => {
                    fRowCLick({ row: item });
                  }}
                  maxHeight="214px"
                  content={
                    <Grid container columnSpacing={{ xs: 2 }}>
                      <Grid item xs={12}>
                        <Stack direction={"row"} justifyContent={"flex-end"}>
                          <CmpStatusIcon xStatus={data?.PA_DocStat} />
                        </Stack>
                      </Grid>
                      <InputDisplay label="Voc No" value={data?.A_VocNo} />
                      <InputDisplay label="Voc Name" value={data?.VocName} />
                      <InputDisplay
                        label="Post Date"
                        value={moment(data?.A_PostDt).format("DD/MM/YYYY")}
                      />
                      <InputDisplay label="Bin Code" value={data?.BinCd} />
                      <InputDisplay label="Bin Name" value={data?.BinName} />
                      <InputDisplay label="Location" value={data?.LocName} />
                      <InputDisplay label="Auto" value={data?.PA_Typ} />
                      <InputDisplay label="Status" value={data?.PA_DocStat} />
                      <InputDisplay
                        label="Party Name"
                        value={data?.PartyName}
                      />
                    </Grid>
                  }
                />
              </Grid>
            ))}
        </Grid>
        {/* <PutAwaySummaryTblCard data={sSummaryGridRow} onClick={fRowCLick} /> */}
      </Box>
      <GCSummaryModal
        xOpen={showModal}
        fCloseModal={() => {
          setShowModal(false);
        }}
        xTitle="Filter"
        component={
          <>
            <Grid container spacing={2} className="align-items-center">
              <Grid item xs={6}>
                <CmpSelectBox
                  xLabelText="Location"
                  xValue={sSummaryObj.loc}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xName={"loc"}
                  xData={vRdxuserLoc}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={6} className="bintransfer-data-date">
                <CmpDatePicker
                  xLabelText={"From"}
                  xValue={sSummaryObj.dateFrom}
                  xOnChange={(newValue) =>
                    setSummaryObj((obj) => ({
                      ...obj,
                      dateFrom: newValue.$d,
                    }))
                  }
                  xName={"dateFrom"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid item xs={6} className="bintransfer-data-date">
                <CmpDatePicker
                  xLabelText={"To"}
                  xValue={sSummaryObj.dateTo}
                  xOnChange={(newValue) =>
                    setSummaryObj((obj) => ({ ...obj, dateTo: newValue.$d }))
                  }
                  xName={"dateTo"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>

              <Grid item xs={6} className="bintransfer-data-date">
                <CmpSelectBox
                  xLabelText="Status"
                  xValue={sSummaryObj.Status}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xName={"Status"}
                  xData={statusData}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={12} className="bintransfer-data-date">
                <CmpTextFieldEnter
                  xref={LocationFocusOnLoad}
                  xLabelText={"GRN.No"}
                  xVariant={"outlined"}
                  xValue={sSummaryObj.GrnNo}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xReadOnly={false}
                  xType={"text"}
                  xName={"GrnNo"}
                  xOnKeyUp={(e) => {
                    fOnKeyUp(e);
                  }}
                  xOnEnter={(e) => {
                    fOnKeyUp(sEnterKeyObj);
                  }}
                  xSmShow={!!vMediaQuery}
                />
              </Grid>

              <Grid
                item
                xs={12}
                className="bintransfet-data-load-btn text-center"
              >
                <CmpButton
                  xbtnName="Load"
                  xOnClick={fLoad}
                  xVariant="contained"
                  xSize="small"
                />
              </Grid>
            </Grid>
          </>
        }
      />
    </div>
  );
}
